import { gql } from '@apollo/client';

export const GET_COUNT_OF_PUBLISHED_MESSAGES = gql`
  query GetCountOfPublishedMessages($dataContractName: String!, $fuzzySearch: Boolean!) {
    getCountOfPublishedMessages(dataContractName: $dataContractName, fuzzySearch: $fuzzySearch) {
      vendorMessagesCount {
        duration
        messageCountDBirth
        messageCountDData
      }
    }
  }
`;
